import { useState } from 'react';
import { useCart } from '../context/CartContext';

export function useAddToCart() {
  const { addToCart } = useCart();
  const [showAddonModal, setShowAddonModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleAddToCart = (product, showAddons = true) => {
    setSelectedProduct(product);
    
    if (showAddons) {
      setShowAddonModal(true);
    } else {
    
      addToCart(product, product.customMessage || '');
    }
  };

  const handleAddWithAddons = (selectedAddonIds = []) => {
    if (selectedProduct) {
      const finalPrice = selectedProduct.finalPrice || selectedProduct.price;
      addToCart(selectedProduct, selectedProduct.customMessage || '');
      setSelectedProduct(null);
      setShowAddonModal(false);
    }
  };

  return {
    showAddonModal,
    setShowAddonModal,
    selectedProduct,
    handleAddToCart,
    handleAddWithAddons
  };
} 